export const WEBLINK = 'Website'
export const APP_STORE = 'AppStore'
export const GOOGLE_PLAY = 'Google Play'
